import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BreakingPillProps {
  visible: boolean;
  className?: string;
}

export function BreakingPill({ visible, className }: BreakingPillProps) {
  if (!visible) return null;
  
  return (
    <div
      className={cn(
        "flex items-center gap-1.5 px-2.5 py-1 bg-destructive text-destructive-foreground",
        "text-xs font-bold uppercase tracking-wider rounded-full animate-pulse",
        "shrink-0",
        className
      )}
      role="status"
      aria-live="polite"
    >
      <AlertCircle className="h-3 w-3" />
      <span>Breaking</span>
    </div>
  );
}
